module.exports = __webpack_public_path__ + "static/eminus-1c8885c90ed4a783a6ed0ab9670d9e16.png";